const envFile = {
  SIGNUP_URL: "https://tenantportal.arrivo.ai/",
  EMAIL_BCC: ["foliolens-emails@vimware.com"],
  DWOLLA_ENVIRONMENT: "production",
  DwOLLA_API_URL: "https://api.dwolla.com",
  PLAID_USERNAME: "Foliolens",
  EXPIRED_DAY: 14,
  reCaptchaKey: "6LdCBD0nAAAAACnzWscpwitI7bco5IJApIgNPSYB", // "6LcQ31UnAAAAAB3FAJBcuypDOqaB0PkNZ1hNVqrD", prod "6LeOnSIjAAAAAEdmKwqWMaG71T5kkHtnnmeSlfoE",
  PUBLIC_API_LINK: "https://a5s10f2o36.execute-api.us-east-1.amazonaws.com",
  ACCESS_TOKEN_LINK: "https://foliolens.auth.us-east-1.amazoncognito.com/oauth2/token",
  SUREAPP_API_LINK: "https://arrivo.sureapp.com",
  PAYABLI_PAYPAGE_API_LINK: "https://paypages.payabli.com",
  PAYABLI_CALLBACK_URL: "https://tenantportal.arrivo.ai/Dashboard",
};
export default envFile;
